import { Container, Header } from "components/Page"
import { css, cx } from "@emotion/css"
import { defaultSort, limitAndOffset } from "api/utils"
import { styledTabClasses, styledTabsProps } from "components/Tabs"

import Breadcrumbs from "components/Breadcrumbs"
import Region from "./Details"
import Surface from "components/Surface"
import { TabLink } from "components/Link"
import Tabs from "@material-ui/core/Tabs"
import { WithAuthority } from "components/WithAuthority"
import { fetchRegions } from "api/regions"
import { sortByDefault } from "../VendorGroups/Details/Suppliers/columns"
import { useI18n } from "providers/I18n"
import { useLocationSearch } from "hooks/useLocationSearch"
import { useQuery } from "react-query"
import { useRouteMatch } from "react-router-dom"

const styles = {
  main: css`
    flex: 1;
    display: flex;
    flex-direction: column;
  `,
  tabContent: css`
    margin-top: var(--spacing-xxl-3);
  `,
  surface: css`
    padding: var(--spacing-xl) var(--spacing-m) var(--spacing-m);
  `,
}
function Regions() {
  const { t } = useI18n()
  const ls = useLocationSearch()
  const params = ls
    .map(limitAndOffset)
    .map(defaultSort(sortByDefault))
    .toString()
  const { data: regions } = useQuery(["regions", params], fetchRegions)
  const match = useRouteMatch<{ tab?: string; id?: string }>()
  const activeTab = match?.params.tab ?? "companies"
  return (
    <Container>
      <Breadcrumbs section={t("nav.admin")} current={t("nav.admin.regions")} />
      <Header label={t("nav.admin.regions")} />
      <Surface mb={2} flexDirection="row" className={styles.surface}>
        <div className={styles.main}>
          <Tabs value={activeTab} {...styledTabsProps}>
            {regions &&
              regions.map((region: any) => (
                <TabLink
                  key={region.code}
                  to={`/admin-regions/${region.code}`}
                  classes={styledTabClasses}
                  className={cx({ [emeaRegion]: region.code === "EMEA" })}
                  value={region.code}
                  label={`${region.name}(${region.code})`}
                />
              ))}
          </Tabs>
          <WithAuthority allowed={["AUTH_VIEW_REGION"]}>
            <div className={styles.tabContent}>
              <Region />
            </div>
          </WithAuthority>
        </div>
      </Surface>
    </Container>
  )
}

export default Regions

const emeaRegion = css`
  min-width: 350px;
`
